$( document ).ready(function() {
    window['_fs_ready'] = function() {
        sessionUrlAtTime = FS.getCurrentSessionURL();
        $("#fsurl").val(sessionUrlAtTime);
    };
    $('.btn-contact').click(function(e) {
        e.preventDefault();
        sendForm($('#contactform'));
    });
    $('#Name').keyup(function ()    { resetFormField('Name', 'Full Name'); });
    $('#Email').keyup(function ()   { resetFormField('Email', 'Email Address'); });
    $('#Message').keyup(function () { resetFormField('Message', 'Your Message'); });
});

function resetFormField($id, $message) {
    $("#"+$id+"Label").removeClass('form-error');
    $("#"+$id+"Label").html($message);
}

function sendForm($formName) {
    var data = $($formName).serialize();
    $.ajax({
        type: "POST",
        data: data,
        url: "/contact",
        success: function (data) {
            errorCount = data.errorCount;
            if(data.errorCount > 0) {
                errors = data;
                $.each( errors , function( key, value ) {
                    firstValue = value.toString().split(',')[0];
                    $('#'+key+'Label').html(firstValue);
                    $('#'+key+'Label').addClass('form-error');
                    //$("#"+key).addClass('otf-fail');
                });
                goToError();
            } else {
                top.location='/contact-sent';
            }
        },
        error: function (jqXHR, textStatus, errorThrown) {
            //console.log(jqXHR.responseText);
        }
    });
}

function goToError() {
    if ($('div').hasClass('form-error')) { // Scroll to first element with an error, if there is one, and focus on the field
        $('.form-error').each(function() {
            $(this).closest('div.accordion-on').find('.form-group, .accordion-button-wrapper').show();
        });
        $(".form-error").first().velocity("scroll", {
            easing: "easeOutQuad",
            offset: -70,
            duration: 500,
            delay: 100
        });
        //$('.form-error').first().parent().siblings('.form-field').find('input, select').first().focus();
    }
}
